import SortableController from '../controllers/sortable_controller';

export default SortableController;